export const testCredentials = {
  email: 'faizu@gow.com',
  password: '12345678',
};
